"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _currency = require("@nerdwallet/currency");

var _motionRotateScaleFade = _interopRequireDefault(require("./motion-rotate-scale-fade"));

var _buttonModule = _interopRequireDefault(require("./button.module.less"));

var _excluded = ["component", "className", "loading", "primary", "tertiary", "block", "disabled", "children", "dangerouslyForceFocusStyling", "dangerouslyForceActiveStyling", "dangerouslyForceHoverStyling", "short"];

var NOOP = function NOOP() {};

var inferComponent = function inferComponent(_ref) {
  var href = _ref.href;
  return href ? 'a' : 'button';
};

var preventDefaultAndStopPropagation = function preventDefaultAndStopPropagation(e) {
  e.preventDefault();
  e.stopPropagation();
};

var getDisabledProps = function getDisabledProps(Component, disabled) {
  if (!disabled) {
    return {};
  }

  if (Component === 'a') {
    return {
      tabIndex: -1,
      'aria-disabled': true,
      onMouseDown: preventDefaultAndStopPropagation,
      onClick: preventDefaultAndStopPropagation
    };
  }

  return {
    disabled: true
  };
};

var getTypeProps = function getTypeProps(Component) {
  // Should use type=button when using a <button> component, but not needed
  // when using <a>. This can be overridden by passing a `type` prop.
  if (Component === 'button') {
    return {
      type: 'button'
    };
  }

  return {};
};

var Button = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames, _classNames2;

  var component = props.component,
      className = props.className,
      loading = props.loading,
      primary = props.primary,
      tertiary = props.tertiary,
      block = props.block,
      disabled = props.disabled,
      children = props.children,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      short = props.short,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var Component = component || inferComponent(otherProps);
  var buttonWrapperClassNames = (0, _classnames.default)(className, _buttonModule.default.buttonWrapper, Component === 'a' && _buttonModule.default['link-button'], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _buttonModule.default.shortButtonWrapper, short), (0, _defineProperty2.default)(_classNames, _buttonModule.default.block, block), (0, _defineProperty2.default)(_classNames, _buttonModule.default.disabled, disabled), _classNames));
  var buttonClassNames = (0, _classnames.default)(_buttonModule.default.button, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, _buttonModule.default.loading, loading), (0, _defineProperty2.default)(_classNames2, _buttonModule.default.primary, !disabled && primary), (0, _defineProperty2.default)(_classNames2, _buttonModule.default.secondary, !disabled && !primary && !tertiary), (0, _defineProperty2.default)(_classNames2, _buttonModule.default.tertiary, !disabled && !primary && tertiary), (0, _defineProperty2.default)(_classNames2, _buttonModule.default['primary-disabled'], disabled && primary), (0, _defineProperty2.default)(_classNames2, _buttonModule.default['secondary-disabled'], disabled && !primary && !tertiary), (0, _defineProperty2.default)(_classNames2, _buttonModule.default['tertiary-disabled'], disabled && !primary && tertiary), (0, _defineProperty2.default)(_classNames2, _buttonModule.default['force-focus'], dangerouslyForceFocusStyling), (0, _defineProperty2.default)(_classNames2, _buttonModule.default['force-hover'], dangerouslyForceHoverStyling), (0, _defineProperty2.default)(_classNames2, _buttonModule.default['force-active'], dangerouslyForceActiveStyling), _classNames2));

  var buttonContent = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: _buttonModule.default['loading-container']
  }, /*#__PURE__*/_react.default.createElement(_motionRotateScaleFade.default, {
    show: loading
  }, /*#__PURE__*/_react.default.createElement(_currency.LoadingSpinner, {
    size: short ? 16 : 24,
    color: primary ? 'green-light' : 'green'
  }))) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: _buttonModule.default.content
  }, children));

  return /*#__PURE__*/_react.default.createElement(Component // bind a noop ontouchstart handler
  // so that ios will style :active states
  , (0, _extends2.default)({
    onTouchStart: NOOP,
    className: (0, _classnames.default)(buttonWrapperClassNames, !short && buttonClassNames),
    ref: ref
  }, getTypeProps(Component), otherProps, getDisabledProps(Component, disabled)), short ? /*#__PURE__*/_react.default.createElement("div", {
    className: _buttonModule.default.shortButtonPadding
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: buttonClassNames
  }, buttonContent)) : buttonContent);
});

Button.displayName = 'Button';
Button.defaultProps = {
  block: false,
  className: null,
  component: null,
  disabled: false,
  primary: false,
  tertiary: false,
  loading: false,
  short: false,
  dangerouslyForceHoverStyling: false,
  dangerouslyForceFocusStyling: false,
  dangerouslyForceActiveStyling: false
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Button.propTypes = {
    children: PropTypes.node.isRequired,

    /** Changes the button to `display: block`, making it go full width. */
    block: PropTypes.bool,

    /** Applies a CSS classname to the component. */
    className: PropTypes.string,

    /**
     * Allows you to provide a React component or other HTML element,
     * overriding the default `a` and `button` options.
     */
    component: PropTypes.string,

    /** Renders a button as disabled, making it non-interactable. */
    disabled: PropTypes.bool,

    /** Renders a button loading visual state. */
    loading: PropTypes.bool,

    /** Renders a visually shorter button */
    short: PropTypes.bool,

    /** Renders a button with the highest visual affordances. */
    primary: PropTypes.bool,

    /** Renders a button with the tertiary visual affordances. */
    tertiary: PropTypes.bool,

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool,

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its active styles. */
    dangerouslyForceActiveStyling: PropTypes.bool
  };
}

var _default = Button;
exports.default = _default;